const validationRules = {
    name: value => {
        if (!value) {
            return 'Name is required';
        } else if (value.length > 50) {
            return 'Name must be less than 50 characters';
        }
        return null;
    },
    queue: value => {
    if (!value) {
       return "Queue Number is required";
    }
    return null;
    },

    email: value => {
        if (!value) {
            return 'Email is required';
        } else if (!/^[A-Z0-9._%+$&-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
            return 'Invalid email address';
        }
        return null;
    },
    

    tpemail: value => {
        if (value && !/^[A-Z0-9._%+$&-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
            return 'Invalid email address';
        }
        return null;
    },

    commaSeparatedEmails: value => {
        if (!value || typeof value !== 'string') return null;
        const emails = value.split(/[,\n]/).map(e => e.trim()).filter(Boolean);
        const emailRegex = /^[A-Z0-9._%+$&-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        for (const email of emails) {
            if (!emailRegex.test(email)) {
                return `Invalid email format: ${email}`;
            }
        }
        return null;
    },

    forgotPasswordEmail: value => {
        if (!value) {
            return 'Email is required';
        } else if (!/^[A-Z0-9._%+$&-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
            return 'Please enter a valid email address';
        }
        return null;
    },

  username: (value) => {
    if (!value) {
      return "Email is required";
    } else if (!/^[A-Z0-9._%+$&-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      return "Please enter a valid email address";
    }
    return null;
  },

  loginPassword: (value) => {
    if (!value) {
      return "Password is required";
    } else if (value.length > 15) {
      return "Password must be less than 15 characters";
    } else if (!/[A-Z]/.test(value)) {
      return "Password must be at least 1 uppercase character";
    } else if (!/[a-z]/.test(value)) {
      return "Password must be at least 1 lowercase character";
    }
    else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
      return "Password must be at least 1 special character";
    } else if (!/[0-9]/.test(value)) {
      return "Password must be at least 1 numeric character";
    }
    return null;
  },

    password: value => {
        if (!value) {
            return 'Password is required';
        }
        else if (value.length < 8) {
            return 'Password must be at least 8 characters';
        } else if (!/[A-Z]/.test(value)) {
            return 'Password must be at least 1 uppercase character';
        } else if (!/[a-z]/.test(value)) {
            return 'Password must be at least 1 lowercase character';
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
            return 'Password must be at least 1 special character';
        } else if (!/[0-9]/.test(value)) {
            return 'Password must be at least 1 numeric character';
        }

        return null;
    },
    contactNumber: value => {
        if (!value) {
            return 'Contact number is required';
        } else if (isNaN(value)) {
            return 'Contact number should only contain numbers'
        }else if (value.length > 20) {
            return "Contact number must be less than 20 characters"
        }else if (value.length < 10) {
            return "Contact number must be higher than 10 characters"
        }
        return null;
    },
    city: value => {
        if (!value) { 
            return 'City is required';
        } else if (value.length > 50) {
            return "City must be less than 50 characters"
        }
        return null;
    },
    groupName: value => {
        if (!value) {
            return 'Group name is required';
        } else if (value.length > 100) {
            return "Group name must be less than 100 characters"
        }
        return null;
    },
    userFirstName: value => {
        if (!value) {
            return 'First name is required';
        }else if (value.length > 50) {
            return "First name must be less than 50 characters"
        }
        return null;
    },
    userLastName: value => {
        if (!value) {
            return 'Last name is required';
        }else if (value.length > 50) {
            return "Last name must be less than 50 characters"
        }
        return null;
    },
    registrationValue: value => {
        if (!value) {
            return 'Registration value is required';
        }else if (value.length > 20) {
            return "Registration value must be less than 20 characters"
        }
        return null;
    },
    tradingPartnerName: value => {
        if (!value) {
            return 'Trading partner name is required';
        }else if (value.length > 100) {
            return "Trading partner name must be less than 100 characters"
        }else if (/\b(NA|N\/A)\b/i.test(value)) {
            return "Trading Partner Name cannot include 'NA' or 'N/A'"
        }
        return null;
    },
    tin: value => {
        if (!value) {
            return 'TIN is required';
        }else if (value.length > 30) {
            return "TIN must be less than 30 characters"
        }
        return null;
    },
    sst: value => {
        if (!value) {
            return 'SST is required';
        }else if (value.length > 30) {
            return "SST must be less than 30 characters"
        }
        return null;
    },
    ttx: value => {
        if (value.length > 30) {
            return "TTX must be less than 30 characters"
        }
        return null;
    },
    companyName: value => {
        if (!value) {
            return 'Company name is required';
        }else if (value.length > 100) {
            return "Company name must be less than 100 characters"
        }
        return null;
    },
    templateName: value => {
        if (!value) {
            return 'Template name is required';
        }else if (value.length > 50) {
            return "Template name must be less than 50 characters"
        }
        return null;
    },
    state: value => {
        if ((value == "Select a State"||value == "Select a Code"||!value)) {
            return 'State is required';
        }
        return null;
    },
    country: value => {
        if (!value) {
            return 'Country is required';
        }
        return null;
    },
    registrationType: value => {
        if (!value) {
            return 'Registration type is required';
        }
        return null;
    },
    msicCode: value => {
        if (!value) {
            return 'MSIC Code is required';
        }
        return null;
    },
    businessActivityDescription: value => {
        if (!value) {
            return 'Business activity description is required';
        }
        return null;
    },
    userType: value => {
        if (!value) {
            return 'User type is required';
        }
        return null;
    },
    templateType: value => {
        if (!value) {
            return 'Template type is required';
        }
        return null;
    },
    templateFile: value => {
        if(!Object.keys(value).includes("uid")) { // check specifid property is there
            return 'Template file is required';
        }
        return null;
    },
    addressLine1: value => {
        if(!value)
        { 
            return "Address line 1 required"
        }
        if (value.length > 150) {
            return "Address line 1 must be less than 150 characters"
        }
        return null;
    },
    addressLine2: value => {
        if(value)
            { 
        if (value.length > 150) {
            return "Address line 2 must be less than 150 characters"
        }}
        return null;
    },
    addressLine3: value => {
        if(value)
            { 
        if (value.length > 150) {
            return "Address line 3 must be less than 150 characters"
        }}
        return null;
    },
    description: value => {
        if(value){
        if (value.length > 255) {
            return "Description must be less than 255 characters"
        }}
        return null;
    },
    postalZone: value => {
        if(value)
        {
        if (value.length > 100) {
            return "Postal Zone must be less than 100 characters"
        }}
        return null;
    },
    tradingPartnerFile: value => {
        if (value === "False") {
            return 'Trading Partner file is required';
        }
        return null;
    },
    fromDate: value => {
        if (!value) {
            return 'From date is required';
        }
        return null;
    },
    toDate: value => {
        if (!value) {
            return 'To date is required';
        }
        return null;
    },
    documentType: value => {
        if (!value) {
            return 'Document type is required';
        }
        return null;
    },
    classification: value => {
        if (!value) {
            return 'Classification is required';
        }
        return null;
    },
    currentPassword: (value) => {
        if (!value) {
          return "Current Password is required";
        }
        return null;
      },
    newPassword: (value) => {
        if (!value) {
          return "Password is required";
        } else if (value.length < 8) {
          return "Password must be at least 8 characters";
        } else if (value.length > 15) {
          return "Password must not exceed 15 characters";
        } else if (!/[A-Z]/.test(value)) {
          return "Password must be at least 1 uppercase character";
        } else if (!/[a-z]/.test(value)) {
          return "Password must be at least 1 lowercase character";
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
          return "Password must be at least 1 special character";
        } else if (!/[0-9]/.test(value)) {
          return "Password must be at least 1 numeric character";
        }
    
        return null;
      },
      loginPasswordWhenLogin : (value)=>
      {
        if (!value) {
            return "Password is required";
          }
           },
    classificationCode :(value) =>{
         if(!value || value == "Select Classification Code")
         { return "Classification Code is Required"}
    },
    companyCode : (value)=>{
        if(!value)
        {
            return "Company Code is Required"
        }
        if(value.length > 50)
        {
            return "Company code should be less than 50 characters"
        }

    },

    //create Company 
    // queue: (value) => {
    // if (!value) {
    //     return "Queue Number is required";
    // }
    // return null;
    // },

};

export default validationRules;